import Education from "../components/Home/education/Education";
import Experience from "../components/Home/experience/Experience";
import Projects from "../components/Home/projects/Projects";
import Skills from "../components/Home/skills/Skills";

export const sectionsData = [
  {
    title: "Experience",
    subtitle: "The companies I've worked with.",
    component: Experience,
  },
  {
    title: "Skills",
    subtitle: "The things I've worked with.",
    component: Skills,
  },
  {
    title: "Projects",
    subtitle: "The Things I have built.",
    component: Projects,
  },
  {
    title: "Education",
    subtitle: "The things I've learnt.",
    component: Education,
  },
];
